var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"py-5"},[_c('p',{staticClass:"text-center mb-0"},[_c('v-icon',{staticClass:"empty-state"},[_vm._v(_vm._s(_vm.icon))])],1),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.message))]),_c('p',{staticClass:"text-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }